// Thin wrapper around PostHog (already loaded via index.html). Silent when PH is absent.
export function trackEvent(name, props = {}) {
    try {
        if (typeof window !== "undefined" && window.posthog) {
            window.posthog.capture(name, props);
        }
    } catch (e) { void e; }
}

export function identifyUser(user) {
    try {
        if (typeof window !== "undefined" && window.posthog && user?.id) {
            window.posthog.identify(user.id, {
                email: user.email,
                name: user.name,
                is_premium: !!user.is_premium,
                locale: user.locale || "en",
            });
        }
    } catch (e) { void e; }
}

export function resetIdentity() {
    try { if (typeof window !== "undefined" && window.posthog) window.posthog.reset(); } catch (e) { void e; }
}
